<template>
  <div class="buyer-seller-form">
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="company.number"
        :placeholder="$t('message.contracts.company_number')"
        autocomplete="off"
        style="cursor: auto"
        id="invoice_company_number"
      />
      <label
        for="invoice_company_number"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.company_number") }}</label
      >
    </span>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="company.name"
        :placeholder="$t('message.contracts.company_name')"
        autocomplete="off"
        style="cursor: auto"
        id="invoice_company_name"
      />
      <label
        for="invoice_company_name"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.company_name") }}</label
      >
    </span>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="company.address"
        :placeholder="$t('message.contracts.company_address')"
        autocomplete="off"
        style="cursor: auto"
        id="inv_company_address"
      />
      <label for="inv_company_address" class="form-label-group-label shorter">{{
        $t("message.contracts.company_address")
      }}</label>
    </span>
    <span
      :class="[
        'bmd-form-group mb-1 d-block  form-label-group',
        country_focused ? 'focused' : '',
      ]"
    >
      <v-select-popup
        type="country"
        v-model="company.country"
        :placeholder="
          $t('message.contracts.invoice_products_OriginCountryCode')
        "
      />
      <!-- <v-select id="invoice_company_country" :options="countries" label="display_text" :class="['form-control', typeof company.country !== 'undefined' && company.country.value!==''?'vs--selected':'']" @search="fetchCountries" @focus="countryFocus" @blur="countryBlur" v-model="company.country" :placeholder="$t('message.contracts.company_country')"></v-select> -->
      <!-- <label for="invoice_company_country" class="form-label-group-label shorter">{{$t('message.contracts.invoice_products_OriginCountryCode')}}</label> -->
    </span>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="company.bank"
        :placeholder="$t('message.contracts.company_bank')"
        autocomplete="off"
        style="cursor: auto"
        id="company_bank"
      />
      <label for="company_bank" class="form-label-group-label shorter">{{
        $t("message.contracts.company_bank")
      }}</label>
    </span>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="company.account"
        :placeholder="$t('message.contracts.company_account')"
        autocomplete="off"
        style="cursor: auto"
        id="company_account"
      />
      <label for="company_account" class="form-label-group-label shorter">{{
        $t("message.contracts.company_account")
      }}</label>
    </span>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="company.p_org_phone"
        :placeholder="$t('message.contracts.company_phone')"
        autocomplete="off"
        style="cursor: auto"
        id="company_phone"
      />
      <label
        for="company_phone"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.company_phone") }}</label
      >
    </span>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="company.p_org_email"
        :placeholder="$t('message.contracts.company_email')"
        autocomplete="off"
        style="cursor: auto"
        id="company_email"
      />
      <label
        for="company_email"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.company_email") }}</label
      >
    </span>
    <span :class="['bmd-form-group mb-2 d-block form-label-group']">
      <input
        type="text"
        class="form-control"
        v-model="company.p_org_fax"
        :placeholder="$t('message.contracts.company_fax')"
        autocomplete="off"
        style="cursor: auto"
        id="company_fax"
      />
      <label
        for="company_fax"
        class="form-label-group-label shorter"
        >{{ $t("message.contracts.company_fax") }}</label
      >
    </span>
    <b-button class="" variant="outline-danger" size="sm" @click="cancel()">
      {{ $t("message.cancel") }}
    </b-button>
    <b-button variant="success" class="float-right" size="sm" @click="save()">
      {{ $t("message.save") }}
    </b-button>
  </div>
</template>
<script>
var querystring = require("querystring");
export default {
  name: "buyer-seller-form",
  props: ["type"],
  data() {
    return {
      country_focused: false,
      countries: [],
      company: {
        number: "",
        name: "",
        address: "",
        country: {
          value: "",
          display_text: "",
        },
        bank: "",
        account: "",
        p_org_phone: "",
        p_org_email: "",
        p_org_fax: "",
      },
    };
  },
  methods: {
    save() {
      let tmp = { ...this.company };
      tmp.country = tmp.country.value;
      axios
        .post(
          window.base +
            "/Document/ContragentCreate?attis_contract_id=" +
            this.$route.params.id +
            "&contragent_type=" +
            this.type,
          querystring.stringify(tmp),
        )
        .then((response) => {
          this.$root.$emit("set." + this.type + ".contragent", {
            company: this.company,
            response: response.data,
          });
          this.cancel();
        });
    },
    cancel() {
      this.$root.$emit(
        "bv::hide::modal",
        "modal-add-" + this.type.replace("courier_next", "courier-next"),
        "#btnShow",
      );
      // this.$root.$emit('bv::hide::modal', 'modal-add-seller', '#btnShow')
    },
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
        });
    },
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 100);
    },
    countryFocus() {
      this.country_focused = true;
    },
    countryBlur() {
      this.country_focused = false;
      // this.validateField('product.attis_cg_TNVED')
    },
  },
  mounted() {
    this.fetchCountries("");
    this.$nextTick(() => {
      setTimeout(() => {
        var el = this;
        $("#inv_company_address").focus(function () {
          el.cus_adr = new ymaps.SuggestView("inv_company_address");
          el.cus_adr.events.add(["select"], (event) => {
            el.company.address = event.get("item").value;
          });
        });
      }, 2000);
    });
  },
};
</script>
